const DEV = process.env.NODE_ENV === 'development';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

import initVideoLightbox from '../util/videoLightbox';

import initInlineVideos from '../util/inlineVideos';

export default {
	init() {

		// JavaScript to be fired on all pages
		console.log('init common');

		const footer = document.querySelector('footer');

		// ScrollSmoother — disabilitato su home, pagine con fullpage.js e pagine con hero fixed
		gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

		const hasFullpage = !!document.querySelector('#fullpage');
		const hasFixedHero = !!document.querySelector('#what-we-do-content, #how-we-work-content');

		if (!hasFullpage && !hasFixedHero) {
			ScrollSmoother.create({
				wrapper: '#smooth-wrapper',
				content: '#smooth-content',
				smooth: 1.5,
				effects: true,
				smoothTouch: 0.1,
			});
		}




		// Remove no-js
		document.documentElement.classList.remove('no-js');
		document.documentElement.classList.add('js');

		// Test touch
		if (!('ontouchstart' in document.documentElement)) {
			document.documentElement.classList.add('no-touch');
		} else {
			document.documentElement.classList.add('touch');
		}

		// AT NAVIGATION
		const body = document.querySelector('body');
		const header = document.querySelector('#masthead');
		const menu = document.querySelector('#at-menu');
		const menuLogo = document.querySelector('#at-menu-logo');
		const languageSwitcher = document.querySelector('#at-language-switcher');

		const hamburger = document.querySelector('#at-hamburger');
		const nav = document.querySelector('#at-nav');

		const aboveTheFold = document.querySelector('.at_atf');		
				
		hamburger.addEventListener('click', toggleMenu);

		function toggleMenu() {
			body.classList.toggle('overflow-hidden');

			header.classList.toggle('h-full');
			header.classList.toggle('altezzaMenu');

			hamburger.classList.toggle('rotate-45')

			nav.classList.toggle('hidden');
			nav.classList.toggle('fade-nav');

			let aboveTheFoldPosition = aboveTheFold.getBoundingClientRect().top;
			if(aboveTheFoldPosition >= 0 && aboveTheFoldPosition > -header.offsetHeight) {
				// gestione menu in hp dove i colori sono invertiti
				if(body.classList.contains('home')){

					if(menuLogo.querySelector('svg').style.fill == 'black'){
						menuLogo.querySelector('svg').style.fill = 'white';
					}
					else {
						menuLogo.querySelector('svg').style.fill = 'black';
					}

					menu.classList.toggle('bg-white');

					languageSwitcher.classList.toggle('text-white');

					//ciclo su tutti i figli del languageSwitcher
					var childrenSwitcher = Array.from(languageSwitcher.children);
					childrenSwitcher.forEach((child) => {
						if(child.classList.contains('border-white') || child.classList.contains('border-black' ) ){
							child.classList.toggle('border-white');
							child.classList.toggle('border-black');
						}
						if(child.classList.contains('bg-white') || child.classList.contains('bg-black') ){
							child.classList.toggle('bg-white');
							child.classList.toggle('bg-black');
						}
					});

					//ciclo su tutti i figli dell'hamburger
					var childrenHamburger = Array.from(hamburger.children);
					childrenHamburger.forEach((child) => {
						if(child.classList.contains('bg-white') || child.classList.contains('bg-black') ){
							child.classList.toggle('bg-white');
							child.classList.toggle('bg-black');
						}
					});
					
					
				}
			}

			if(body.classList.contains('home')){
				menu.classList.toggle('border-b');
				menu.classList.toggle('border-black');
			}
			
		}

		// HEADER SCROLL E VERSO IL BASSO SPARISCE VERSO L'ALTO, E RIAPPARE QUANDO SI SCROLLA VERSO L'ALTO
		let lastScrollTop = 0;
		window.addEventListener('scroll', function () {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			if (scrollTop > lastScrollTop) {
				header.classList.add('-translate-y-full');
			} else {
				header.classList.remove('-translate-y-full');
			}
			lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
		}, false);
		

		// AT CUSTOM ANIMATION

		const projectGallery = document.querySelector(
			'#at-project-gallery-container'
		);

		const projectGalleryCol1 = document.querySelector(
			'#at-project-gallery-1'
		);
		const projectGalleryCol2 = document.querySelector(
			'#at-project-gallery-2'
		);
		const projectGalleryCol3 = document.querySelector(
			'#at-project-gallery-3'
		);

		if (projectGallery) {
			let projectGalleryTl = gsap.timeline({
				scrollTrigger: {
					trigger: projectGallery,
					start: 'top bottom',
					end: 'top center',
					scrub: 1,
				},
			});
			if (
				projectGalleryCol1 &&
				projectGalleryCol2 &&
				projectGalleryCol3
			) {
				projectGalleryTl.to(
					[
						projectGalleryCol1,
						projectGalleryCol2,
						projectGalleryCol3,
					],
					{
						y: '0%',
						duration: 1,
						ease: 'none',
					}
				);
			}
		}

		console.log('step 3');

		//Video lightbox
		const protectVideo = (video) => {
			if (video.dataset.protected) return;
			video.dataset.protected = '1';
			video.setAttribute('controlsList', 'nodownload noremoteplayback');
			video.setAttribute('disablePictureInPicture', '');
			video.setAttribute('disableRemotePlayback', '');
			video.addEventListener('contextmenu', (e) => e.preventDefault());
		};

		// fallback: blocca il menu contestuale su qualsiasi <video> della pagina
		document.addEventListener(
			'contextmenu',
			(e) => {
				if (e.target && e.target.closest('video')) e.preventDefault();
			},
			true
		);

		initVideoLightbox(protectVideo);

		initInlineVideos(protectVideo);

		// AT FOOTER
		jQuery(document).ready(function ($) {
			function updateFooterFullpage() {
				if ($('#fullpage').length) {
					var $footer = $('#fullpage_footer.real-footer'),
						$fixedFooter = $('#fullpage_footer.clone-footer');
					$fixedFooter.html($footer.html());
				}
			}
			updateFooterFullpage();
		});

	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		console.log('finalize common');
	},
};
